import { Patient } from "./patient.model";
import { ScannedSpecimen } from "./scanned-specimen.model";

export class TestOrder {
  GUID?: string;
  PatientId: number;
  PatientName: string;
  PanelGuids: Array<number>;
  SelectedPanels: Array<TestOrderPanel>;
  LocationId: number;
  LocationName: string;
  ReleaseOn?: string;
  ICDCodeIds: Array<number>;
  SelectedCodes: Array<ICDCode>;
  PhysicianId: string;
  PhysicianName: string;
  ReleaseYear?: string;
  ReleaseMonth?: string;
  ReleaseDay?: number;
  PatientDob?: string;
  TempPatient?: Patient;
  Specimens?: ScannedSpecimen[];
  Attestation?: string;
  isGenalytePatient?: boolean;
  SelfTestingCenter?: boolean;
  BillingClaim?: any;
  PaymentReceiptToken?: string;
  PaymentId?: string;

  constructor() {
    this.PanelGuids = [];
    this.SelectedPanels = [];
    this.ICDCodeIds = [];
    this.SelectedCodes = [];
    this.ReleaseYear = null;
    this.ReleaseMonth = null;
    this.ReleaseDay = null;
    this.PaymentReceiptToken = null;
    this.PaymentId = null;
    this.Specimens = [];
  }

  getPayload = () => {
    return {
      PatientId: this.PatientId,
      ICDCodes: this.ICDCodeIds,
      PanelIds: this.PanelGuids,
      PhysicianId: this.PhysicianId,
      ReleasedOn: this.ReleaseOn,
      LocationId: this.LocationId
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/models/test-order.model.ts